import { Component, OnInit, ChangeDetectionStrategy, Inject, OnDestroy, ViewChild } from '@angular/core';
import { RegistroActividadLaboratorioFormComponent } from '../registro-actividad-laboratorio-form.component';
import { Store, select } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { State } from '../../../vista-usuario/vista-usuario.state';
import { Laboratorio } from '../../entity-laboratorios/laboratorios.model';
import { NotificationService } from 'projects/registro-personas-empresas/src/app/core/core.module';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { entityLaboratoriosAddRequest } from '../../entity-laboratorios/laboratorios.actions';
import { selectAllLaboratoriosFromCurrentEmpresa } from '../../entity-laboratorios/laboratorios.selectors';

@Component({
  selector: 'rpe-registro-actividad-laboratorio-form-container',
  templateUrl: './registro-actividad-laboratorio-form-container.component.html',
  styleUrls: ['./registro-actividad-laboratorio-form-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegistroActividadLaboratorioFormContainerComponent implements OnInit, OnDestroy {
  @ViewChild(RegistroActividadLaboratorioFormComponent)
  formComponent: RegistroActividadLaboratorioFormComponent;

  subscriptions: Subscription[] = []

  laboratorio: Laboratorio = null
  laboratoriosCurrentEmpresa: Laboratorio[] = []

  formInvalid: boolean = false

  newLab: Laboratorio = null

  constructor(
    private store: Store<State>,
    private notificationService: NotificationService,
    private dialogRef: MatDialogRef<RegistroActividadLaboratorioFormContainerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      laboratorio?: Laboratorio
    },
  ) { }

  ngOnInit(): void {
    this.store.pipe(
      select(selectAllLaboratoriosFromCurrentEmpresa)
    ).subscribe((labs) => {
      this.laboratoriosCurrentEmpresa = labs
    })

    if (this.data.laboratorio) {
      this.laboratorio = this.data.laboratorio
    }
  }

  ngOnDestroy(): void {
    if (this.subscriptions.length) {
      this.subscriptions.forEach((s) => s.unsubscribe())
    }
  }

  formStatusChange(status: string): void {
    if (status === 'INVALID') {
      this.formInvalid = true
    }

    if (status === 'VALID') {
      this.formInvalid = false
    }
  }

  formValueChange($event: Laboratorio): void {
    if ($event.id) {
      //Laboratorio editado
      const editedLab = this.laboratoriosCurrentEmpresa.find((lab) => lab.id === $event.id)

      //Eliminamos el laboratorio editado
      this.laboratoriosCurrentEmpresa = this.laboratoriosCurrentEmpresa.filter((lab) => lab.id != editedLab.id)

      //Agregamos el laboratorio editado
      this.laboratoriosCurrentEmpresa = [...this.laboratoriosCurrentEmpresa, $event]
    }

    if (!$event.id) {
      //Laboratorio nuevo
      this.newLab = $event
    }
  }

  onAdd(): void {
    if (this.formInvalid) {
      this.notificationService.info('Complete los campos requeridos')
      this.formComponent?.checkErrors()
      return
    }

    this.store.dispatch(
      entityLaboratoriosAddRequest({
        //Agregamos el nuevo laboratorio si existe
        item: this.newLab ? [...this.laboratoriosCurrentEmpresa, this.newLab] : this.laboratoriosCurrentEmpresa
      })
    )

    this.dialogRef.close()
  }

  onCancel(): void {
    this.dialogRef.close()
  }
}
